import React from 'react'

const Point = () => (
  <svg className='w-[20px] h-[20px]' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h17.746v17.746H0z"/>
      <path fill="currentcolor" d="M8.873 2.662a6.211 6.211 0 1 1 0 12.422 6.211 6.211 0 0 1 0-12.422zM9.6 6.158H6.942v6.06h1.541V10.44h1.02c1.349 0 2.277-.844 2.277-2.137 0-1.302-.882-2.146-2.18-2.146zm-.411 1.18c.646 0 1.033.34 1.033.97 0 .634-.387.974-1.042.974h-.697V7.338z"/>
    </g>
  </svg>
)

export default Point